import { IdentityInputTypeEnum } from "@repo/core/components/forms/IdentityTypeInput/types";
import { useState } from "react";
import { IdentityInputHookProps } from "./types";
import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";

export const useIdentityTypeInput = ({
  onSelectProduct
}: IdentityInputHookProps) => {
  const [selectedIdentityInputType, setSelectedIdentityInputType] = useState(
    IdentityInputTypeEnum.CPF
  );

  const [productInfo, setProductInfo] =
    useState<CardConsultDataResponseDTO | null>(null);

  const handleOnChangeIdentityType = (identity: string) => {
    setSelectedIdentityInputType(identity as IdentityInputTypeEnum);
  };

  const handleOnSelectProduct = (productInfo?: CardConsultDataResponseDTO) => {
    if (productInfo) {
      setProductInfo(productInfo);
    }

    onSelectProduct?.(productInfo);
  };

  return {
    productInfo,
    handleOnChangeIdentityType,
    handleOnSelectProduct,
    selectedIdentityInputType
  };
};
